export default [
  {
    path: '/',
    name: 'Login',
    component: () => import('@/components/functions/Auth/PgLogin')
  },
  {
    path: '/Top',
    name: 'Top',
    component: () => import('@/components/functions/Top/TopIndex')
  },
  {
    path: '/D0101Demo',
    name: 'D0101Demo',
    component: () => import('@/components/functions/D0101Demo/D0101DemoIndex')
  },
  {
    path: '/M0001User',
    name: 'M0001User',
    component: () => import('@/components/functions/M0001User/M0001UserIndex')
  },
  {
    path: '/M0001UserEditForm/:invite',
    name: 'M0001UserEditForm',
    component: () => import('@/components/functions/CreateNewUser/CreateUserIndex')
  },
  {
    path: '/M0002SNSLink',
    name: 'M0002SNSLink',
    component: () => import('@/components/functions/M0002SNSLink/M0002SNSLinkIndex')
  },
  {
    path: '/M0002SNSLink/:code',
    name: 'M0002SNSLink',
    component: () => import('@/components/functions/M0002SNSLink/M0002SNSLinkIndex')
  },
  {
    path: '/M0005ScheduleList',
    name: 'M0005ScheduleList',
    component: () => import('@/components/functions/M0005ScheduleList/M0005ScheduleListIndex')
  },
  {
    path: '/M0006SNSReport',
    name: 'M0006SNSReport',
    component: () => import('@/components/functions/M0006SNSReport/M0006SNSReportIndex')
  },
  {
    path: '/M0007SNSPostComments',
    name: 'M0007SNSPostComments',
    component: () => import('@/components/functions/M0007SNSPostComments/M0007SNSPostCommentsIndex')
  },
  {
    path: '/TestPublish',
    name: 'TestPublish',
    component: () => import('@/components/functions/TestPublish/TestPublishIndex')
  },
  {
    path: '*',
    redirect: '/'
  }
]
